module.exports = __webpack_public_path__ + "static/timeline-bg-298d0aa4fec6338870e6b18503a0b554.jpg";